const translation = {
  // Navbar
  nav_home: 'Home',
  nav_destinations: 'Destinations',
  nav_gallery: 'Gallery',
  nav_offers: 'IAEE 2026 CHILE',
  nav_testimonials: 'Testimonials',
  nav_contact: 'Contact',
  nav_assistant: 'Assistant',

  // Hero
  hero_title: 'Discover Chile with GaLi Travel',
  hero_subtitle: 'Your adventure starts here',
  hero_cta: 'Explore Destinations',

  // Destinations
  dest_title: 'Must-See Destinations',
  dest_subtitle: 'From the arid Atacama Desert to the glaciers of Patagonia, Chile offers a unique diversity of landscapes and unforgettable experiences.',
  dest_see_more: 'See more',

  // Offers
  offers_badge: 'EXCLUSIVE OFFERS',
  offers_title: 'Travel More,\nSpend Less',
  offers_subtitle: 'Take advantage of our special promotions and discover Chile at the best prices. Packages designed so you can live unique experiences without compromising your budget.',
  offers_see_all: 'See All Offers',
  offers_valid_until: 'Valid until',
  offers_book_now: 'Book Now',

  // Testimonials
  test_title: 'What Our Travelers Say',

  // Contact
  contact_title: 'Plan Your Next Trip',
  contact_subtitle: 'Fill out the form and we will get in touch with you',
  contact_name: 'Full Name',
  contact_name_placeholder: 'Your name',
  contact_email: 'Email Address',
  contact_phone: 'Phone',
  contact_phone_placeholder: '+56 9 1234 5678',
  contact_destination: 'Destination',
  contact_destination_select: 'Select',
  contact_date: 'Travel Date',
  contact_travelers: 'Number of Travelers',
  contact_person: 'person',
  contact_persons: 'persons',
  contact_message: 'Message',
  contact_message_placeholder: 'Tell us about your ideal trip...',
  contact_chars: 'characters',
  contact_submit: 'Send Request',
  contact_submitting: 'Sending...',
  contact_success: 'Message sent successfully! We will contact you soon.',
  contact_error: 'There was an error sending the message. Please try again.',
  contact_phone_label: 'Phone',
  contact_email_label: 'Email',
  contact_whatsapp: 'WhatsApp',
  contact_whatsapp_available: 'Available 24/7',
  contact_hours: 'Business Hours',
  contact_hours_weekdays: 'Monday to Friday: 9:00 - 19:00',
  contact_hours_saturday: 'Saturday: 10:00 - 14:00',
  contact_quick_response: 'Quick Response',
  contact_quick_response_text: 'We respond to all inquiries within 24 hours',

  // Footer
  footer_about: 'About Us',
  footer_our_story: 'Our Story',
  footer_team: 'Team',
  footer_values: 'Values',
  footer_work_with_us: 'Work With Us',
  footer_popular_dest: 'Popular Destinations',
  footer_resources: 'Resources',
  footer_travel_blog: 'Travel Blog',
  footer_destination_guides: 'Destination Guides',
  footer_travel_tips: 'Travel Tips',
  footer_faq: 'FAQ',
  footer_contact: 'Contact',
  footer_rights: '© 2024 GaLi Travel Chile. All rights reserved.',
  footer_terms: 'Terms & Conditions',
  footer_privacy: 'Privacy',
  footer_cert_sernatur: 'Sernatur Certified',
  footer_cert_safe: 'Safe Tourism',
};

export default translation;
